import React, { useEffect, useState } from "react";
import Input from "../../../../components/controls/Input";
import { useForm } from "../../../../components/forms/useForm";
import SetupSlideOverFormActions from "../SetupSlideOverFormActions";
import { useSlideOverSubmit } from "../useSlideOverSubmit";
import { Dialog } from "@headlessui/react";
import DocumentUi from "../../../importMedia/DocumentUi";
import { XMarkIcon } from "@heroicons/react/24/outline";

const initialFValues = {
  name: "",
  city: "",
  address1: "",
  address2: "",
  zip: "",
  province: "",
  country: "",
  notes: "",
  uploaded_cert_1: null,
  uploaded_cert_2: null,
  uploaded_cert_3: null,
};

export default function LaboratoryDetailsForm(props) {
  const { actionCall, item, isEdit, setOpen, title } = props;

  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    // simple required check for name
    if ("name" in fieldValues)
      temp.name = fieldValues.name ? null : "This field is required.";

    setErrors({ ...temp });

    return Object.values(temp).every((x) => x === null);
  };

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    true,
    validate,
  );
  const { submitting, runSubmit } = useSlideOverSubmit();

  const [cert1, setCert1] = useState(null);
  const [cert2, setCert2] = useState(null);
  const [cert3, setCert3] = useState(null);

  useEffect(() => {
    if (!item) return;
    setValues({
      ...initialFValues,
      ...item,
    });
  }, [item, setValues]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    runSubmit(async () => {
      const hasFiles = cert1 || cert2 || cert3;
      if (hasFiles) {
        const fd = new FormData();
        Object.keys(values).forEach((k) => {
          if (
            values[k] !== undefined &&
            values[k] !== null &&
            typeof values[k] !== "object"
          ) {
            fd.append(k, values[k]);
          }
        });
        if (cert1) fd.append("uploaded_cert_1[]", cert1);
        if (cert2) fd.append("uploaded_cert_2[]", cert2);
        if (cert3) fd.append("uploaded_cert_3[]", cert3);
        await actionCall(fd);
      } else {
        await actionCall(values);
      }
    });
  };

  return (
    <form className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between">
            <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
              {title}
            </Dialog.Title>
            <div className="ml-3 flex h-7 items-center">
              <button
                type="button"
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                onClick={() => setOpen({ childComponent: null, open: false })}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <div className="relative mt-6 flex-1 px-4 sm:px-6 space-y-5">
          <div className="grid grid-cols-2 gap-5">
            <Input
              label="Name"
              name="name"
              onChange={handleInputChange}
              value={values.name}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Contact Name"
              name="contact_name"
              onChange={handleInputChange}
              value={values.contact_name}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Email"
              name="email"
              onChange={handleInputChange}
              value={values.email}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Phone #"
              name="phone"
              onChange={handleInputChange}
              value={values.phone}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="grid grid-cols-2 gap-5">
            <Input
              label="City"
              name="city"
              onChange={handleInputChange}
              value={values.city}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Address 1"
              name="address1"
              onChange={handleInputChange}
              value={values.address1}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Address 2"
              name="address2"
              onChange={handleInputChange}
              value={values.address2}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Zip"
              name="zip"
              onChange={handleInputChange}
              value={values.zip}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Province"
              name="province"
              onChange={handleInputChange}
              value={values.province}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Country"
              name="country"
              onChange={handleInputChange}
              value={values.country}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Notes"
              name="notes"
              onChange={handleInputChange}
              value={values.notes}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="grid grid-cols-3 gap-2">
            <DocumentUi
              title="Certification 1"
              uploadedImage={cert1}
              setUploadedImage={setCert1}
              isEdit={isEdit}
              imageUrl={values.cert_1_url}
              imageName="uploaded_cert_1"
              handleInputChange={handleInputChange}
              onDelete={() => {
                setValues({
                  ...values,
                  cert_1: "",
                  cert_1_url: null,
                });
                setCert1(null);
              }}
              showNameInput={true}
              nameInput="cert_1_name"
              nameInputValue={values.cert_1_name}
            />
            <DocumentUi
              title="Certification 2"
              uploadedImage={cert2}
              setUploadedImage={setCert2}
              isEdit={isEdit}
              imageUrl={values.cert_2_url}
              imageName="uploaded_cert_2"
              handleInputChange={handleInputChange}
              onDelete={() => {
                setValues({
                  ...values,
                  cert_2: "",
                  cert_2_url: null,
                });
                setCert2(null);
              }}
              showNameInput={true}
              nameInput="cert_2_name"
              nameInputValue={values.cert_2_name}
            />
            <DocumentUi
              title="Certification 3"
              uploadedImage={cert3}
              setUploadedImage={setCert3}
              isEdit={isEdit}
              imageUrl={values.cert_3_url}
              imageName="uploaded_cert_3"
              handleInputChange={handleInputChange}
              onDelete={() => {
                setValues({
                  ...values,
                  cert_3: "",
                  cert_3_url: null,
                });
                setCert3(null);
              }}
              showNameInput={true}
              nameInput="cert_3_name"
              nameInputValue={values.cert_3_name}
            />
          </div>
        </div>
      </div>
      <SetupSlideOverFormActions
        setOpen={setOpen}
        isEdit={isEdit}
        submitting={submitting}
        onSubmit={handleSubmit}
      />
    </form>
  );
}
